import React from 'react';

import { Body, Modal, Title } from '@icarros/ids-react';

import { ReactComponent as NPSIllustration } from '../../../assets/rebranding/institucional/depoimentos.svg';

import { ModalBody } from './style';

interface FeedbackErrorProps {
  modalOpen: boolean;
  handleClose: () => void;
  handleRetry: () => void;
  loading: boolean;
}

export function FeedbackError({
  modalOpen,
  handleClose,
  handleRetry,
  loading
}: FeedbackErrorProps): JSX.Element {
  return (
    <Modal
      stateOpen={[
        modalOpen,
        () => {
          handleClose();
        }
      ]}
      body={
        <ModalBody>
          <NPSIllustration />
          <Title variant="default" size="base">
            desculpe, não conseguimos enviar as informações
          </Title>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Tente enviar novamente a sua avaliação.
          </Body>
        </ModalBody>
      }
      title=""
      secondaryButtonText="tentar novamente"
      secondaryButtonMethod={() => handleRetry()}
      secondaryButtonLoading={loading}
    />
  );
}
